import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { openChat } from '@/components/ChatButton';
import { openSupport } from '@/components/SupportButton';

// Reads ?tab=&match=&auction=&chat= from the URL (set by notification clicks)
// and returns the id to highlight. Cards must render id={`deeplink-${id}`}.
export const useDeepLink = (setActiveTab, validTabs) => {
  const location = useLocation();
  const [highlightId, setHighlightId] = useState(null);

  useEffect(() => {
    const p = new URLSearchParams(location.search);
    const tab = p.get('tab');
    if (tab && validTabs.includes(tab)) setActiveTab(tab);
    const chat = p.get('chat');
    if (chat) openChat({ conversation_id: chat });
    const support = p.get('support');
    if (support) openSupport(support);
    setHighlightId(p.get('match') || p.get('auction') || null);
  }, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!highlightId) return undefined;
    let tries = 0;
    const t = setInterval(() => {
      const el = document.getElementById(`deeplink-${highlightId}`);
      tries += 1;
      if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); clearInterval(t); }
      if (tries > 10) clearInterval(t);
    }, 400);
    return () => clearInterval(t);
  }, [highlightId]);

  return highlightId;
};

export const highlightClass = (highlightId, id) => (highlightId === id ? ' ring-2 ring-emerald-500 ring-offset-2' : '');

export const deliveryLabel = (mode) => (mode === 'delivery' ? 'Entrega a domicilio' : mode === 'pickup' ? 'Recogida en el proveedor' : 'Flexible');
